import { render, staticRenderFns } from "./index.vue?vue&type=template&id=131b6f5a&scoped=true&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./index.scss?vue&type=style&index=0&id=131b6f5a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131b6f5a",
  null
  
)

export default component.exports